export default __webpack_public_path__ + "static/media/ovalbread.7096074f.jpg";